import {
  LinkItem,
  RulesOfUseContent,
  RulesOfUseContentList,
  RulesOfUseItem,
  RulesOfUseItemTitle,
  RulesOfUseTitle,
  Wrapper,
} from "./style";

export const RulesOfUse = () => {
  return (
    <Wrapper>
      <RulesOfUseTitle>УСЛОВИЯ ИСПОЛЬЗОВАНИЯ САЙТА</RulesOfUseTitle>

      <RulesOfUseItem>
        <RulesOfUseItemTitle>Общие термины и определения</RulesOfUseItemTitle>

        <RulesOfUseContent>
          Контент — изображения, текстовые, аудио- и видеоматериалы, а также сообщения любого характера, содержащиеся на сайте <LinkItem to='https://as.dushanbe24.ru/' target='blank'>as.dushanbe24.ru</LinkItem> (далее — «Сайт») и/или в мобильном приложении Dushanbe24 (далее — «Мобильное приложение»).
        </RulesOfUseContent>

        <RulesOfUseContent>
          Личный кабинет — индивидуальный раздел пользователя на Сайте или в Мобильном приложении, защищённый параметрами авторизации, доступ к которому осуществляется путём ввода идентифицирующих данных (логин и пароль или логин и код) или путём авторизации с помощью аккаунта в социальной сети, в котором содержится информация о совершённых пользователем заказах. Личный кабинет регистрируется на адрес электронной почты пользователя и на номер телефона пользователя автоматически после оформления заказа на Сайте или в Мобильном приложении либо после прохождения пользователем процедуры регистрации личного кабинета на Сайте или в Мобильном приложении. Информация о заказах доступна только самому зарегистрированному пользователю
        </RulesOfUseContent>

        <RulesOfUseContent>
          Логин — адрес электронной почты пользователя или номер телефона пользователя.
        </RulesOfUseContent>

        <RulesOfUseContent>
          Мобильное приложение Dushanbe24 (далее — «Мобильное приложение») — предназначенная для установки и использования на мобильном устройстве (планшет, мобильный телефон, смартфон, коммуникатор, иное устройство, позволяющее использовать Мобильное приложение по его функциональному назначению) программное обеспечение (ПО), позволяющее пользователю получить доступ к функционалу платформы транспортных билетных сервисов, включая программные модули, являющиеся составными частями платформы и/или дополняющие её.
        </RulesOfUseContent>
        
        <RulesOfUseContent>
          Пароль или код — наборы латинских букв и/или цифр, необходимые для доступа в Личный кабинет, которые в сочетании с Логином служат идентифицирующими данными пользователя.
        </RulesOfUseContent>
        
        <RulesOfUseContent>
          Платформа транспортных билетных сервисов (далее — «Платформа») — принадлежащий правообладателю программный комплекс, обеспечивающий автоматизацию процесса планирования и организации пользователем поездок в личных целях как при помощи интерфейса веб-сайта <LinkItem to='https://as.dushanbe24.ru/' target='blank'>as.dushanbe24.ru</LinkItem>, составной частью которого является Платформа, так и при помощи мобильного приложения Dushanbe24, предназначенный для осуществления процесса поиска и формирования единой комбинированной выдачи, выбора, бронирования, оформления, приобретения (оплаты) и возврата электронных авиабилетов, электронных проездных документов на железнодорожный транспорт, электронных билетов на автобус, выбора и бронирования номеров для временного размещения и проживания гостей в средствах/объектах размещения или иных дополнительных услуг при помощи функционала Платформы.
        </RulesOfUseContent>

        <RulesOfUseContent>
          Мобильное приложение Dushanbe24 (далее — «Мобильное приложение») — предназначенная для установки и использования на мобильном устройстве (планшет, мобильный телефон, смартфон, коммуникатор, иное устройство, позволяющее использовать Мобильное приложение по его функциональному назначению) программное обеспечение (ПО), позволяющее пользователю получить доступ к функционалу платформы транспортных билетных сервисов, включая программные модули, являющиеся составными частями платформы и/или дополняющие её.
        </RulesOfUseContent>

        <RulesOfUseContent>
          Пользователь — право- и дееспособное физическое лицо, пользующееся Сайтом, Мобильным приложением в собственном интересе либо выступающее от имени и в интересах представляемого им иного лица.
        </RulesOfUseContent>
        
        <RulesOfUseContent>
          Правообладатель — юридическое лицо, которое является разработчиком и правообладателем платформы транспортных билетных сервисов.
        </RulesOfUseContent>

        <RulesOfUseContent>
          Сайт <LinkItem to='https://as.dushanbe24.ru/' target='blank'>as.dushanbe24.ru</LinkItem> (далее — «Сайт») — самостоятельный составной мультимедийный продукт в значении ст. 1260 ГК РФ, модули и кросс-модульные компоненты которого используются обществом с ограниченной ответственностью «С-Сервис» (ОГРН 1117746943434, ИНН 7729696371) (далее — «Исполнитель») на законных основаниях для оказания услуг, предусмотренных целями публичных оферт, опубликованных на Сайте.
        </RulesOfUseContent>
      </RulesOfUseItem>

      <RulesOfUseItem>
        <RulesOfUseItemTitle>2. Общие положения</RulesOfUseItemTitle>

        <RulesOfUseContent>
          2.1. Исполнитель, действующий на законных основаниях, в соответствии с заключённым договором с Правообладателем на предоставление услуг удалённого доступа предлагает Пользователю безвозмездно использовать Сайт, Мобильное приложение на условиях, изложенных в настоящем пользовательском соглашении (далее — «Соглашение»):

          <RulesOfUseContentList>
            — возможность осуществления Пользователем через доступ к Платформе посредством Сайта или Мобильного приложения действий по поиску и просмотру расписания различных видов транспорта; действий по формированию и оплате заказа;
          </RulesOfUseContentList>
          <RulesOfUseContentList>
            — осуществление процесса поиска и формирования для Пользователя единой комбинированной выдачи, выбора, бронирования, оформления, приобретения (оплаты) и возврата электронных авиабилетов;
          </RulesOfUseContentList>
          <RulesOfUseContentList>
            — техническое решение для Пользователя-физического лица, включающее возможность ведения личного кабинета на Сайте или в Мобильном приложении;
          </RulesOfUseContentList>
          <RulesOfUseContentList>
            — возможность осуществления автоматизированной коммуникации Пользователя с Исполнителем через различные каналы связи (смс, мессенджеры, социальные сети), форму обратной связи, email-канал.
          </RulesOfUseContentList>
        </RulesOfUseContent>

        <RulesOfUseContent>
          Функциональные возможности Платформы распространяются в виде Интернет-сервиса. Исполнитель имеет право взимать сервисный сбор за оказываемые услуги в соответствии с условиями публичной оферты, размещенной на странице <LinkItem to='https://as.dushanbe24.ru/public-offer-info/' target='blank'>as.dushanbe24.ru/public-offer-info</LinkItem>.
        </RulesOfUseContent>

        <RulesOfUseContent>
          Акцептом Соглашения является выполнение Пользователем одного из следующих действий: открытие любой страницы Сайта или Мобильного приложения, либо нажатие соответствующей кнопки при регистрации или авторизации.
        </RulesOfUseContent>

        <RulesOfUseContent>
          2.2. Настоящее Соглашение может быть изменено Исполнителем без специального уведомления Пользователя; новая редакция вступает в силу с момента её размещения в сети Интернет по адресу <LinkItem to='https://as.dushanbe24.ru/rules-of-use-info/' target='blank'>as.dushanbe24.ru/rules-of-use-info/</LinkItem>, если иное не предусмотрено новой редакцией Соглашения.
        </RulesOfUseContent>

        <RulesOfUseContent>
          2.3. Настоящее Соглашение представляет собой соглашение между Пользователем и Исполнителем и устанавливает условия и правила использования Пользователем Сайта, Мобильного приложения, Личного кабинета, в том числе условия использования размещенного и/или размещаемого Контента, включая, но не ограничиваясь, текстовыми материалами, изображениями, комментариями Пользователя.
        </RulesOfUseContent>

        <RulesOfUseContent>
          Положения настоящего Соглашения являются обязательными для всех Пользователей.
        </RulesOfUseContent>

        <RulesOfUseContent>
          2.4. В случае несогласия Пользователя с какими-либо из положений Соглашения, Пользователь не вправе использовать Сайт и/или Мобильное приложение и должен воздержаться от их использования. В случае если Исполнителем были внесены какие-либо изменения в Соглашение в порядке, предусмотренном пунктом 2.2. Соглашения, с которыми Пользователь не согласен, он обязан прекратить использование Сайта и/или Мобильного приложения.
        </RulesOfUseContent>

        <RulesOfUseContent>
          2.5. Персональная информация Пользователя хранится и обрабатывается Исполнителем в соответствии с условиями Политики ООО «С-Сервис» в отношении обработки персональных данных. Ознакомиться с политикой ООО «С-Сервис» в отношении обработки персональных данных можно на странице <LinkItem to='https://as.dushanbe24.ru/privacy-policy-info/' target='blank'>as.dushanbe24.ru/privacy-policy-info/</LinkItem>.
        </RulesOfUseContent>

        <RulesOfUseContent>
          2.7. Пользуясь Сайтом или Мобильным приложением, Пользователь соглашается с тем, что неотъемлемыми частями настоящего Соглашения являются следующие документы:

          <RulesOfUseContentList>
            — Пользовательское соглашение об условиях и порядке использования сервиса, размещенное в сети Интернет по адресу: <LinkItem to='https://as.dushanbe24.ru/rules-of-use-info/' target='blank'>as.dushanbe24.ru/rules-of-use-info/</LinkItem>.
          </RulesOfUseContentList>

          <RulesOfUseContentList>
            — Политика ООО «С-Сервис» в отношении обработки персональных данных, размещенная по адресу: <LinkItem to='https://as.dushanbe24.ru/privacy-policy-info/' target='blank'>as.dushanbe24.ru/privacy-policy-info/</LinkItem>.
          </RulesOfUseContentList>
        </RulesOfUseContent>

        <RulesOfUseContent>
          2.8. При использовании данного сервиса, Пользователь принимает условия использования сервиса, размещенные на странице <LinkItem to='https://as.dushanbe24.ru/rules-of-use-info/' target='blank'>as.dushanbe24.ru/rules-of-use-info/</LinkItem>.
        </RulesOfUseContent>
      </RulesOfUseItem>

      <RulesOfUseItem>
        <RulesOfUseItemTitle>3. Регистрация Пользователя. Личный кабинет</RulesOfUseItemTitle>

        <RulesOfUseContent>
          3.1. Для пользования Сайтом и/или Мобильным приложением регистрация не обязательна. Личный кабинет регистрируется автоматически после оформления заказа.
        </RulesOfUseContent>

        <RulesOfUseContent>
          3.2. Для регистрации Личного кабинета без оформления заказа пользователю необходимо нажать кнопку «Регистрация» и указать e-mail, имя и фамилию. После регистрации придёт письмо или СМС с кодом подтверждения.
        </RulesOfUseContent>

        <RulesOfUseContent>
          3.3. Для входа в Личный кабинет нужно нажать кнопку «Войти» и ввести логин и пароль/код. Восстановление пароля — через форму на Сайте.
        </RulesOfUseContent>

        <RulesOfUseContent>
          3.4. Пользователь несёт ответственность за сохранность своих данных и должен выходить из Личного кабинета после работы.
        </RulesOfUseContent>
      </RulesOfUseItem>

      <RulesOfUseItem>
        <RulesOfUseItemTitle>4. Использование Сайта и Мобильного приложения</RulesOfUseItemTitle>

        <RulesOfUseContent>
          4.1. Сайт и/или Мобильное приложение предоставляют доступ к услугам через ПК и мобильные устройства.
        </RulesOfUseContent>

        <RulesOfUseContent>
          4.2. Пользователь соглашается с наличием рекламы и автоматических уведомлений.
        </RulesOfUseContent>

        <RulesOfUseContent>
          4.3. Исполнитель не несёт ответственности за настройки пользователя и не гарантирует соответствие Сайта целям Пользователя.
        </RulesOfUseContent>
      </RulesOfUseItem>

      <RulesOfUseItem>
        <RulesOfUseItemTitle>5. Условия использования</RulesOfUseItemTitle>

        <RulesOfUseContent>
          5.1. Пользователь самостоятельно несёт ответственность за свои действия и соблюдение законодательства РФ.
        </RulesOfUseContent>

        <RulesOfUseContent>
          5.2. При использовании Сайта и/или Мобильного приложения Пользователь не вправе:
            <RulesOfUseContentList>
              — выдавать себя за другого человека;
            </RulesOfUseContentList>
            <RulesOfUseContentList>
              — размещать контент без прав;
            </RulesOfUseContentList>
            <RulesOfUseContentList>
              — нарушать работу Сайта;
            </RulesOfUseContentList>
            <RulesOfUseContentList>
              — нарушать законодательство РФ.
            </RulesOfUseContentList>
        </RulesOfUseContent>
      </RulesOfUseItem>

      <RulesOfUseItem>
        <RulesOfUseItemTitle>6. Исключительные права</RulesOfUseItemTitle>

        <RulesOfUseContent>
          6.1. Пользователь обязуется не воспроизводить, не копировать, не продавать и не использовать для коммерческих целей элементы Сайта и/или Мобильного приложения без разрешения Исполнителя.
        </RulesOfUseContent>

        <RulesOfUseContent>
          6.2. Все объекты на Сайте являются объектами исключительных прав Правообладателя.
        </RulesOfUseContent>
      </RulesOfUseItem>

      <RulesOfUseItem>
        <RulesOfUseItemTitle>7. Сайты третьих лиц</RulesOfUseItemTitle>

        <RulesOfUseContent>
          7.1. Сайт может содержать ссылки на другие сайты. Исполнитель не несёт ответственности за их контент.
        </RulesOfUseContent>
      </RulesOfUseItem>

      <RulesOfUseItem>
        <RulesOfUseItemTitle>8. Реклама</RulesOfUseItemTitle>

        <RulesOfUseContent>
          8.1. Ответственность за рекламу несёт рекламодатель.
        </RulesOfUseContent>
      </RulesOfUseItem>

      <RulesOfUseItem>
        <RulesOfUseItemTitle>9. Перерывы в работе</RulesOfUseItemTitle>

        <RulesOfUseContent>
          9.1. Исполнитель имеет право приостанавливать работу Сайта для профилактических работ.
        </RulesOfUseContent>
      </RulesOfUseItem>

      <RulesOfUseItem>
        <RulesOfUseItemTitle>10. Обратная связь</RulesOfUseItemTitle>

        <RulesOfUseContent>
          10.1. Пользователь может направить обращение через форму обратной связи на Сайте.
        </RulesOfUseContent>
      </RulesOfUseItem>

      <RulesOfUseItem>
        <RulesOfUseItemTitle>11. Ответственность</RulesOfUseItemTitle>

        <RulesOfUseContent>
          11.1. Исполнитель не гарантирует бесперебойную работу Сайта и не несёт ответственности за убытки Пользователя.
        </RulesOfUseContent>
      </RulesOfUseItem>

      <RulesOfUseItem>
        <RulesOfUseItemTitle>12. Конфиденциальность</RulesOfUseItemTitle>

        <RulesOfUseContent>
          12.1. Обеспечивается тайна сообщений и конфиденциальность информации о Пользователях.
        </RulesOfUseContent>
      </RulesOfUseItem>

      <RulesOfUseItem>
        <RulesOfUseItemTitle>13. Иные положения</RulesOfUseItemTitle>

        <RulesOfUseContent>
          13.1. Настоящее Соглашение регулируется законодательством РФ.
        </RulesOfUseContent>
      </RulesOfUseItem>
    </Wrapper>
  );
};
